/**
 * lucide-react v0.0.1 - ISC
 */

import createLucideIcon from '../createLucideIcon.mjs';

const Minus = createLucideIcon("Minus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }]
]);

export { Minus as default };
//# sourceMappingURL=minus.mjs.map
